import {Button, Form} from "react-bootstrap";
import {useState} from "react";
import Message from "../message";

function JobScraperBulk() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

    const [inputFile, set_inputFile] = useState("");
    const [status_inputFile, setStatus_inputFile] = useState("");

    const submit_inputFile = async () => {
        setStatus_inputFile("");

        if (inputFile.length <= 0) {
            setStatus_inputFile("Upload Delivery Excel File!");
        } else {
            setStatus_inputFile("Processing Files...");

            const formDatainputFile = new FormData();
            formDatainputFile.append("file", inputFile);

            const requestOptions = {
                method: "POST",
                body: formDatainputFile,
            };

            console.log(formDatainputFile);

            try {
                const inputFile_response = await fetch(
                    apiServer + `api/job_scraper_bulk/upload_file`,
                    requestOptions
                );
                const inputFile_status_id = await inputFile_response.json();
                const inputFile_status = inputFile_status_id.detail
                    ? inputFile_status_id.detail
                    : inputFile_status_id;
                setStatus_inputFile(inputFile_status);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{marginTop: "20px"}}>
            <Form.Control
                type="file"
                name="verifier"
                id="verifier"
                className="verifierxcls"
                onChange={(e) => set_inputFile(e.target.files[0])}
            />
            <Button
                style={{
                    marginTop: "1.25rem",
                    marginRight: "1rem",
                    backgroundColor: "#3a4c7a",
                    border: "none",
                }}
                href="./templates/bulk_job_scraper.xlsx"
                download
            >
                Download Template
            </Button>
            <Button
                variant="primary"
                type="button"
                style={{marginTop: "15px"}}
                onClick={() => submit_inputFile()}
            >
                Submit
            </Button>
            {Message(status_inputFile, setStatus_inputFile)}
        </div>
    );
}

export default JobScraperBulk;